var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sort",on:{"click":function($event){return _vm.toList(_vm.data.foodTypeId)}}},[_c('div',{staticClass:"sort-img"},[_c('img',{attrs:{"src":_vm.data.pictureName,"alt":""}})]),_c('p',{staticClass:"sort-title"},[_vm._v(_vm._s(_vm.data.foodTypeName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }